import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/lib/api-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Retrying a 4xx repeats a request the server has already rejected on its
        // merits. Only transient failures are worth a second attempt.
        if (error instanceof ApiError && error.isClientError) return false;
        return failureCount < 1;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

/** Reference data changes rarely; a longer stale time avoids refetching it per page. */
export const REFERENCE_DATA_STALE_TIME = 5 * 60_000;
